// extracted by mini-css-extract-plugin
export default {"header":"Header_header__WqQOz","logo":"Header_logo__I6sxO","active":"Header_active__1yx4L"};